import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAsyncCallback } from '../../../../hooks'
import { ConfirmationModal } from '../../../Confirmation'
import { getInitialActiveWidget } from '../../DocFlowMapping'
import { MappingWidgetType } from '../../DocFlowMappingWidgets'
import {
  getUploadingWidgetProcess,
  resetUploadingFilesProcess,
  updateDocFlowUploadingFileProcess,
} from '../../DocFlowUploading'
import { useDocFlowContext } from '../useDocFlowContext'

export function useDocFlowMappingFileProcess({
  setActiveWidget,
  onReloadUploadingFilesAll,
  onResetCurrentSelectedArea,
}) {
  const { t } = useTranslation()

  const {
    documentId,
    handleCloseModal,
    handleReloadDocFlow,
    mappingPhaseFileActive,
    setModal,
  } = useDocFlowContext()

  const [processData, setProcessData] = useState(null)
  const [isProcessDataLoading, setProcessDataLoading] = useState(null)

  const getFileProcess = useAsyncCallback(() => {
    setProcessDataLoading(true)

    return getUploadingWidgetProcess({
      documentId,
      itemId: mappingPhaseFileActive,
    })
      .then(({ data }) => {
        setProcessData(data)

        return data
      })
      .finally(() => {
        setProcessDataLoading(false)
      })
  }, [documentId, mappingPhaseFileActive])

  const handleUpdateFileProcess = useAsyncCallback(
    data => {
      setProcessDataLoading(true)

      return updateDocFlowUploadingFileProcess({
        data,
        id: documentId,
        itemId: mappingPhaseFileActive,
      })
        .then(response => {
          setProcessData(response.data)

          return response.data
        })
        .finally(() => {
          setProcessDataLoading(false)
        })
    },
    [documentId, mappingPhaseFileActive]
  )

  function handleResetProcess() {
    handleCloseModal()

    resetUploadingFilesProcess({
      documentId,
      itemId: mappingPhaseFileActive,
    }).then(({ data }) => {
      setProcessData(data)
      onReloadUploadingFilesAll()
      handleReloadDocFlow()
      setActiveWidget(MappingWidgetType.Type)
      onResetCurrentSelectedArea()
    })
  }

  function handleClickResetButton() {
    setModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitText: t('DocumentStapling.MappingPhaseResetProcessBtntKey'),
        }}
        description={t(
          'DocumentStapling.MappingPhaseResetProcessConfirmTextKey'
        )}
        onCancel={handleCloseModal}
        onSubmit={handleResetProcess}
      />
    )
  }

  useEffect(() => {
    if (mappingPhaseFileActive) {
      getFileProcess().then(data => {
        setActiveWidget(getInitialActiveWidget(data))
      })
    }
  }, [mappingPhaseFileActive])

  return {
    getFileProcess,
    handleClickResetButton,
    handleUpdateFileProcess,
    isProcessDataLoading,
    processData,
    setProcessData,
  }
}
